<template>
    <div class="myBiaoZhu" id="myBiaoZhuDiv">
        <div v-show="img != null" class="codics-hbb-biaozhu-control">
            <el-button class="codics-hbb-biaozhu-control-btn" type="warning" @click="startBiaoZhu"
                plain>开始标注</el-button>
            <el-button class="codics-hbb-biaozhu-control-btn" style="margin-left: 15px;" type="success"
                @click="endBiaoZhu" plain>标注完成</el-button>
        </div>
        <img id="myBiaoZhu" v-show="img != null" :src="img" alt="标注图">
        <el-dialog title="收货地址" :visible.sync="banMaVisible">
            <el-form :model="banMaForm">
                <el-form-item label="绑定标签" :label-width="'110px'">
                    <el-select v-model="banMaForm.tag" placeholder="请选择要绑定的标签" clearable filterable>
                        <el-option v-for="(item, index) in tagsData" :key="index" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="banMaVisible = false">取 消</el-button>
                <el-button type="primary" @click="bindTag">确 定</el-button>
            </div>
        </el-dialog>
        <el-upload v-show="img == null" class="codics-hbb-biaozhu-upload" :http-request="uploadFile"
            :show-file-list="false" drag :limit="1" action="files.kylebing.cn" accept="image/*">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将图片文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <el-dialog title="添加信息" :visible.sync="addVisible">
            <el-form :model="banMaForm" :label-width="'110px'">
                <el-form-item label="标记图名称" required>
                    <el-input v-model="banMaForm.title" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="标记图介绍" required>
                    <el-input v-model="banMaForm.detail" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="addBanmaFuc">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as qiniu from 'qiniu-js';
import { mapState } from 'vuex';
import { listTags, getQiNiuToken, addBanma } from '@/api';
import { randomString } from '@/utils/myutils';
export default {
    name: '',
    components: {},
    data() {
        return {
            addVisible: false,
            img: null,
            tagsData: [],
            nowEl: null,
            banMaVisible: false,
            nowId: null,
            banMa: [],           //斑马线的数组
            canBiaoZhu: false,  //是否可以进行标注
            pointColor: '',   //点的颜色
            pointSize: 10,       //点的大小
            tagName: '',
            banMaForm: {
                title: '',
                detail: '',
                img: '',
                state: 0,
                list: []
            },
            qiNiuInfo: {
                token: null
            },
        }
    },
    methods: {
        async addBanmaFuc() {
            if (this.banMaForm.title == '' || this.banMaForm.detail == '') {
                this.$message.error('请输入标记图信息！');
                return;
            }
            this.banMaForm.list = [...this.banMa];
            const loading = this.$loading({
                lock: true,
                text: '添加中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await addBanma(this.banMaForm);
            loading.close();
            if (data.code == 200) {

                this.$message({
                    message: '添加成功',
                    type: 'success'
                });

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }
        },
        async getTokenFuc() {
            let data = await getQiNiuToken();
            if (data.code == 200) {
                this.qiNiuInfo.token = data.uptoken;
            } else {
                this.$message.error(data.message);
            }
        },
        uploadFile(uploadInfo) {

            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            let imgPath = 'huayuan/img/' + randomString(10) + '_' + new Date().getTime() + '_' + this.userInfo?.user?.id + '.png';

            const _that = this;
            // 上传文件
            const observer2 = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    loading.close();
                    // console.log(err)
                },
                complete(res) {
                    loading.close();
                    // console.log('complete: ', res)
                    _that.img = 'https://cdn.bosscaigou.com/' + res.key;

                    _that.banMaForm.img = _that.img;

                }
            }
            // console.log(uploadInfo.file);
            const observable2 = qiniu.upload(uploadInfo.file, imgPath, this.qiNiuInfo.token, {}, {
            })
            const subscription2 = observable2.subscribe(observer2) // 上传开始

        },
        async listTagsFuc() {
            const res = await listTags();
            this.tagsData = res.data;
        },
        bindTag() {
            const _this = this;
            const item = _this.banMa.find(item => item.id === _this.nowId)
            item.tag = _this.banMaForm.tag;
            _this.nowEl.setAttribute('data-tag', _this.banMaForm.tag);
            _this.banMaVisible = false;
        },
        //开始标注
        startBiaoZhu() {
            this.canBiaoZhu = true
        },
        //完成标注
        endBiaoZhu() {
            let tag = this.banMa.find(item => item.tag === '');
            if (tag) {
                this.$message.error('还有未绑定标签的标注！');
                return;
            }
            this.canBiaoZhu = false;
            this.addVisible = true;
        },
        //画点
        createMarker(x, y) {
            const _this = this;
            var div = document.createElement('div')
            const id = this.banMa.length;
            div.className = `com-hbb-order-marker marker${id}`;
            y = y + document.getElementById('myBiaoZhu').offsetTop - this.pointSize / 2
            x = x + document.getElementById('myBiaoZhu').offsetLeft - this.pointSize / 2
            div.style.width = this.pointSize + 'px'
            div.style.height = this.pointSize + 'px'
            div.style.position = 'absolute'
            div.style.backgroundColor = 'rgba(0,0,0,0)'
            div.innerHTML = '<div class="com-hbb-order-marker-inner"></div>'
            div.style.left = x + 'px'
            div.style.top = y + 'px'
            div.setAttribute('data-tag', '');
            div.onclick = function () {
                console.log(this);
                const item = _this.banMa.find(item => item.id === id)
                _this.nowId = item.id;
                _this.nowEl = this;
                _this.banMaVisible = true;
            };
            div.oncontextmenu = ((e) => {
                document.getElementById('myBiaoZhuDiv').removeChild(div)
                console.log(id);  //删除该点的id
                this.banMa = this.banMa.filter(item => item.id !== id)
                if (e && e.preventDefault) {
                    //阻止默认浏览器动作(W3C)
                    e.preventDefault()
                } else {
                    //IE中阻止函数器默认动作的方式
                    window.event.returnValue = false
                }
                return false
            })  //阻止冒泡行为和默认右键菜单事件，删除该点
            document.getElementById('myBiaoZhuDiv').appendChild(div)
        },
    },
    watch: {},
    computed: {
        ...mapState(['userInfo'])
    },
    created() {

    },
    mounted() {
        this.getTokenFuc();
        document.getElementById('myBiaoZhu').oncontextmenu = ((e) => {
            if (e && e.preventDefault) {
                //阻止默认浏览器动作(W3C)
                e.preventDefault()
            } else {
                //IE中阻止函数器默认动作的方式
                window.event.returnValue = false
            }
            return false
        })      //阻止冒泡行为和默认右键菜单事件
        document.getElementById('myBiaoZhu').onmousedown = (e) => {
            const _that = this;
            e = e || window.event
            if (e.button !== 2) {       //判断是否右击
                if (this.canBiaoZhu) {    //判断是否可以进行标注
                    var x = e.offsetX || e.layerX
                    var y = e.offsetY || e.layerY
                    console.log(x, y)
                    var myImg = document.querySelector("#myBiaoZhu")
                    var currWidth = myImg.clientWidth
                    var currHeight = myImg.clientHeight
                    var ProportionWidthInImg = x / currWidth
                    var ProportionHeightInImg = y / currHeight
                    // console.log("图片比例高度："+ProportionHeightInImg)
                    // console.log("图片比例宽度："+ProportionWidthInImg)
                    this.banMa.push({
                        id: this.banMa.length + 1,
                        tag: '',
                        x,
                        y
                    })
                    this.createMarker(x, y)
                }
            }
        }
        this.listTagsFuc();
    },
    beforeDestroy() {

    },
    destroyed() {

    },
}
</script>

<style>
#myBiaoZhuDiv {
    position: relative;
    height: calc(100% - 50px);
    min-height: 100vh;
    width: 100%;
    float: left;
    box-sizing: border-box;
    overflow-y: scroll;
}

#myBiaoZhuDiv .marker {
    position: absolute !important;
    border-radius: 50%;
    z-index: 999;
}

#myBiaoZhuDiv img {
    border: solid 1px #000;
    display: inline-block;
    z-index: 0;
}

#myBiaoZhu {
    width: fit-content;
    height: fit-content;
    position: relative;
    float: left;
    margin-left: 15px;
}

.com-hbb-order-marker {
    transition: .3s;
    transform-origin: center center;
    cursor: pointer;
    z-index: auto;
    isolation: isolate
}

.com-hbb-order-marker-inner {
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: red;
    border-radius: 50%;
    transition: .3s
}

.com-hbb-order-marker:hover {
    transform: scale(1.5);
}

.com-hbb-order-marker::before {
    content: attr(data-tag);
    position: absolute;
    margin: auto;
    top: 0;
    left: -10px;
    right: 0;
    bottom: 0;
    z-index: -1;
    height: 21.3333px;
    width: fit-content;
    text-align: right;
    line-height: 21.3333px;
    font-size: 8px;
    background: #FFF;
    color: #333;
    padding: 0 10px 0 31.3333px;
    border-radius: 10.65px;
    transition: .3s;
    opacity: 0;
    white-space: nowrap;
}

.com-hbb-order-marker:hover::before {
    opacity: 1;
}

.codics-hbb-biaozhu-upload {
    position: absolute !important;
    margin: auto;
    top: -100px;
    left: 0;
    right: 0;
    bottom: 0;
    height: fit-content;
    width: fit-content;
}

.codics-hbb-biaozhu-control {
    height: 70px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding-left: 15px;
}

.codics-hbb-biaozhu-control-btn {
    position: relative;
    float: left;
    top: 50%;
    transform: translateY(-50%);
}
</style>